import { render, staticRenderFns } from "./JhakaasInput.vue?vue&type=template&id=05a6ebc4"
import script from "./JhakaasInput.vue?vue&type=script&lang=js"
export * from "./JhakaasInput.vue?vue&type=script&lang=js"
import style0 from "./JhakaasInput.vue?vue&type=style&index=0&id=05a6ebc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports